/**
 * Wrapper de react-markdown con GFM (listas, negritas, tablas) para el
 * Action Center Premium (0669).
 *
 * react-markdown@10 es seguro por defecto: no renderiza HTML embebido (no hay
 * dangerouslySetInnerHTML internamente). Los componentes son tipados.
 * remark-gfm añade soporte a tablas + autolinks + checkboxes.
 *
 * Aplicado en el campo `alcance` del modal detalle (texto descriptivo amplio
 * con `**negrita**`, `\n`, `•` listas).
 */

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export interface MarkdownProps {
  source: string;
}

export function Markdown(props: MarkdownProps) {
  return (
    <div
      style={{
        fontSize: 13,
        lineHeight: 1.6,
        color: '#1F2937',
        fontFamily: 'DM Sans, sans-serif',
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children }) => <p style={{ margin: '0 0 10px 0', lineHeight: 1.6 }}>{children}</p>,
          strong: ({ children }) => (
            <strong style={{ fontWeight: 700, color: '#1F3864' }}>{children}</strong>
          ),
          ul: ({ children }) => (
            <ul style={{ margin: '0 0 10px 0', paddingLeft: 20, lineHeight: 1.6 }}>{children}</ul>
          ),
          ol: ({ children }) => (
            <ol style={{ margin: '0 0 10px 0', paddingLeft: 20, lineHeight: 1.6 }}>{children}</ol>
          ),
          li: ({ children }) => <li style={{ marginBottom: 4 }}>{children}</li>,
          h1: ({ children }) => (
            <h4
              style={{
                margin: '12px 0 8px 0',
                fontSize: 14,
                fontWeight: 700,
                color: '#1F3864',
              }}
            >
              {children}
            </h4>
          ),
          h2: ({ children }) => (
            <h5
              style={{
                margin: '12px 0 6px 0',
                fontSize: 13,
                fontWeight: 700,
                color: '#1F3864',
              }}
            >
              {children}
            </h5>
          ),
          h3: ({ children }) => (
            <h6
              style={{
                margin: '10px 0 6px 0',
                fontSize: 12,
                fontWeight: 700,
                color: '#374151',
                textTransform: 'uppercase',
                letterSpacing: 0.4,
              }}
            >
              {children}
            </h6>
          ),
          a: ({ children, href }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#2F5496', textDecoration: 'underline' }}
            >
              {children}
            </a>
          ),
          code: ({ children }) => (
            <code
              style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: 12,
                background: '#F3F4F6',
                padding: '1px 4px',
                borderRadius: 3,
                color: '#374151',
              }}
            >
              {children}
            </code>
          ),
        }}
      >
        {props.source}
      </ReactMarkdown>
    </div>
  );
}
